import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS } from '../config.js';

export default function Verify() {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage(t('verify.verificationError'));
      return;
    }

    fetch(`${API_ENDPOINTS.VERIFY}/${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStatus('success');
          setMessage(data.message || t('verify.verificationSuccess'));
          setTimeout(() => navigate('/login'), 5000);
        } else {
          setStatus('error');
          setMessage(data.error || t('verify.verificationError'));
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage(t('verify.verificationError'));
      });
  }, [token, navigate]);

  return (
    <div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc'}}>
      <div style={{background: 'white', borderRadius: 16, boxShadow: '0 4px 24px rgba(30,41,59,0.10)', padding: 36, maxWidth: 400, width: '100%', textAlign: 'center'}}>
        {status === 'loading' && <div>{t('verify.verifyingEmail')}</div>}
        {status === 'success' && (
          <div>
            <div style={{color: '#22c55e', fontWeight: 700, fontSize: 20, marginBottom: 12}}>✔️ {message}</div>
            <div style={{color: '#64748b'}}>{t('verify.redirectingMessage')}</div>
          </div>
        )}
        {status === 'error' && (
          <div style={{color: '#ef4444', fontWeight: 700, fontSize: 20}}>{message}</div>
        )}
      </div>
    </div>
  );
} 